import { Link } from '@tanstack/react-router';
import { Send, SlidersHorizontal, UserPlus } from 'lucide-react';
import { cn } from '@/lib/utils';

type Tab = 'configuration' | 'test';

const TABS: { key: Tab; label: string; icon: typeof UserPlus }[] = [
  { key: 'configuration', label: 'Configuration', icon: SlidersHorizontal },
  { key: 'test', label: 'Test Intake', icon: Send },
];

/**
 * Shared header for lead settings. The test tab keeps the ingest/routing
 * validation tool near configuration without presenting it as a separate module.
 */
export function LeadsEngineTabs({ active, showTest = true }: { active: Tab; showTest?: boolean }) {
  const tabs = showTest ? TABS : TABS.filter((tab) => tab.key !== 'test');

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-foreground text-background">
          <UserPlus className="h-4 w-4" />
        </span>
        <h1 className="text-lg font-semibold">Lead Settings</h1>
      </div>
      <div className="flex gap-1 border-b">
        {tabs.map((tab) => {
          const isActive = tab.key === active;
          const Icon = tab.icon;
          return (
            <Link
              key={tab.key}
              to="/dashboard/settings/leads"
              search={tab.key === 'test' ? { tab: 'test' } : {}}
              className={cn(
                '-mb-px flex items-center gap-1.5 border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-foreground text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )}
            >
              <Icon className="h-4 w-4" />
              {tab.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
